export const handleApplyAction = (isAuthenticated: boolean, userPermissions: any, challengeId: string, isEvent: boolean = false): string => {
  if (isAuthenticated && userPermissions?.features?.some((feature) => feature.code === 'idea')) {
    return getApplyRoute(challengeId)
  }
  return isEvent ? getEventRoute(challengeId) : getChallengeRoute(challengeId)
}

export const getApplyRoute = (challengeId: string): string => {
  return `/hub/startup/challenge/${challengeId}`
}

export const getChallengeRoute = (challengeId: string): string => {
  return `/challenge/${challengeId}`
}

export const getEventRoute = (eventId: string): string => {
  return `/event/${eventId}`
}
